import { getSupabaseClient } from '../../../../core/supabase/client.js';

export interface NotificationSettingsDto {
  user_id: string;
  assigned_tasks_push: boolean;
  assigned_issues_push: boolean;
  follow_checkin_push: boolean;
  follow_checkout_push: boolean;
  follow_activity_push: boolean;
  follow_inactivity_push: boolean;
  inactivity_scope: 'following' | 'all';
  inactivity_threshold_minutes: number;
  follow_out_of_geofence_push: boolean;
  out_of_geofence_scope: 'following' | 'all';
}

const FIELDS =
  'user_id, assigned_tasks_push, assigned_issues_push, follow_checkin_push, follow_checkout_push, follow_activity_push, follow_inactivity_push, inactivity_scope, inactivity_threshold_minutes, follow_out_of_geofence_push, out_of_geofence_scope';

export class NotificationSettingsRemoteDataSource {
  private get supabase() {
    return getSupabaseClient() as any;
  }

  async get(userId: string): Promise<NotificationSettingsDto | null> {
    const { data, error } = await this.supabase
      .from('user_notification_settings')
      .select(FIELDS)
      .eq('user_id', userId)
      .maybeSingle();
    if (error) throw new Error(error.message);
    return (data ?? null) as NotificationSettingsDto | null;
  }

  async upsert(dto: NotificationSettingsDto): Promise<void> {
    const { error } = await this.supabase
      .from('user_notification_settings')
      .upsert({ ...dto, updated_at: new Date().toISOString() }, { onConflict: 'user_id' });
    if (error) throw new Error(error.message);
  }
}
